import '@digdir/designsystemet-theme';
import '@digdir/designsystemet-css';
import '@brreg/designsystemet-theme/css/brreg.css';
import '@enonic/react-components/utils/initPublicPath';
import { AppProps } from '/types/AppProps';
import type { MetaData } from '@enonic/react-components';
import { BaseComponent } from '@enonic/react-components';
import * as React from 'react';
import { componentRegistry } from '../componentRegistry';
import '/site/common.css';
import { Footer } from '/lib/components/footer/footer';
import { SkipLink } from '@digdir/designsystemet-react';
import { useEffect } from 'react';
import { Header } from '/lib/components/header/header';

const App: React.FC<AppProps> = ({ component, data, common, meta }) => {
	const compMeta: MetaData = meta as MetaData;
	compMeta.componentRegistry = componentRegistry;

	// console.log('component: ' + JSON.stringify(component, null, 2));
	// console.log('common: ' + JSON.stringify(common, null, 2));
	// console.log('meta: ' + JSON.stringify(meta, null, 2));

	return (
		<div className="default-page">
			<SkipLink href="#main-content">Hopp til innhold</SkipLink>
			<ColorSchemeSetter />
			<Header
				logoImageSvgData={common.logoImageSvgData as string}
				menuItems={common.menuItems as any[]}
			/>
			<BaseComponent
				component={component}
				data={data}
				common={common}
				meta={compMeta}
			/>
			<Footer logoImageSvgData={common.logoImageSvgData as string} />
		</div>
	);
};

const ColorSchemeSetter = () => {
	useEffect(() => {
		const applySystemColorScheme = () => {
			const prefersDark = window.matchMedia(
				'(prefers-color-scheme: dark)',
			).matches;
			document.body.setAttribute(
				'data-color-scheme',
				prefersDark ? 'dark' : 'light',
			);
		};

		applySystemColorScheme();
		window
			.matchMedia('(prefers-color-scheme: dark)')
			.addEventListener('change', applySystemColorScheme);
	}, []);
};

App.displayName = 'App';

export default App;
